module.exports = __webpack_public_path__ + "static/media/cert_4992.d5051259.jpg";